import { useState, useEffect } from "react";
import { useApi } from "../../hooks/use-api";
import {
  API_VOCABULARY_DAILY_WORDS,
  API_VOCABULARY_QUIZ,
  API_VOCABULARY_QUIZ_SUBMIT,
} from "../../utils/api-routes";
import { useSingleton } from "../../hooks/use-singleton";

export const useHandler = () => {
  const { post } = useApi();
  const { mail } = useSingleton();
  const [wordsData, setWordsData] = useState(null);
  const [quizData, setQuizData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getDailyWords = async ({ level, count }) => {
    try {
      setLoading(true);

      const payload = {
        level: level,
        count: count,
        user_mail: mail,
      };

      const response = await post(API_VOCABULARY_DAILY_WORDS, payload);
      setWordsData(response.data);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getVocabularyQuiz = async ({ level, count }) => {
    try {
      setLoading(true);

      const payload = {
        level: level,
        count: count,
        user_mail: mail,
      };

      const response = await post(API_VOCABULARY_QUIZ, payload);
      setQuizData(response.data);
    } catch (error) {
      console.error("Error fetching quiz data:", error);
    } finally {
      setLoading(false);
    }
  };

  const submitVocabularyQuiz = async ({ quizToken, level, answers }) => {
    try {
      setLoading(true);

      const res = await post(API_VOCABULARY_QUIZ_SUBMIT, {
        quiz_token: quizToken,
        user_mail: mail,
        level: level.toLowerCase(),
        answers,
      });

      return {
        success: true,
        data: res?.data,
      };
    } catch (error) {
      return {
        success: false,
        error,
      };
    } finally {
      setLoading(false);
    }
  };

  return {
    wordsData,
    setWordsData,
    getDailyWords,
    quizData,
    setQuizData,
    getVocabularyQuiz,
    submitVocabularyQuiz,
    loading,
    setLoading,
  };
};
